<template>
	<div class="address">
		<security-info />
		<p class="mb_10">{{ $t('merchant.address.text1') }}</p>
		<div class="select_wrap mb_20">
			<select class="contact_type" v-model="selected_asset_seq">
				<option class="no_value" value="" selected disabled>
					{{ $t('merchant.address.select') }}
				</option>
				<option
					v-for="item in assets"
					:key="item.seq"
					:value="item.seq"
					:label="item.title"
				/>
			</select>
		</div>
		<div v-if="isCertification">{{ $t('merchant.address.text4') }}</div>
		<div v-if="!isCertification && !isKrw">
			<p class="mb_10">{{ $t('merchant.address.text2') }}</p>
			<input
				type="text"
				:placeholder="$t('merchant.address.text3')"
				class="mb_10"
				v-model="params.address"
			/>
		</div>
		<div v-if="isKrw">
			<p class="mb_10">{{ $t('merchant.address.text5') }}</p>
			<div class="select_wrap mb_20">
				<select class="contact_type" v-model="params.strBankCode">
					<option class="no_value" value="" selected disabled>
						{{ $t('merchant.address.select') }}
					</option>
					<option
						v-for="(item, idx) in constants.kyc
							.asset_withdraw_address_certification.bank_codes"
						:key="idx"
						:value="item[0]"
						:label="item[1]"
					/>
				</select>
			</div>
			<p class="mb_10">{{ $t('merchant.address.text6') }}</p>
			<input
				type="text"
				:placeholder="$t('merchant.address.text6')"
				class="mb_20"
				v-model="params.strNm"
			/>
			<p class="mb_10">{{ $t('merchant.address.text7') }}</p>
			<input
				type="text"
				:placeholder="$t('merchant.address.text7')"
				class="mb_20"
				v-model="params.strAccountNo"
			/>
			<p class="mb_10">{{ $t('merchant.address.text8') }}</p>
			<input
				type="text"
				:placeholder="$t('merchant.address.text9')"
				class="mb_10"
				v-model="params.strResId"
			/>
		</div>
		<button
			v-if="!isCertification"
			class="button_bg_red"
			@click="createWithdrawAddressCertification"
		>
			{{ $t('merchant.address.register') }}
		</button>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Merchant/Certification/SecurityInfo';
import { mapGetters, mapState } from 'vuex';
import { createWithdrawAddress, fetchWithdrawAddressList } from '@/api/kyc';
import { commonError } from '@/common/dialog';

export default {
	name: 'Address',
	components: { SecurityInfo },
	data() {
		return {
			params: {
				asset_seq: null,
				strBankCode: '',
				strNm: '',
				strAccountNo: null,
				strResId: '',
				address: '',
			},
			selected_asset_seq: '',
			certification_asset_list: [],
			isCertification: false,
			isKrw: false,
		};
	},
	computed: {
		...mapGetters('assets', ['assets']),
		...mapState('common', ['constants']),
		selected_asset() {
			return this.assets.find(item => {
				return item.seq === this.selected_asset_seq;
			});
		},
	},
	watch: {
		selected_asset() {
			const asset = this.certification_asset_list.find(item => {
				return item.asset_seq === this.selected_asset_seq;
			});
			if (asset) {
				this.isCertification = true;
				this.isKrw = false;
			} else {
				this.isCertification = false;
				this.isKrw = this.selected_asset?.code === 'KRW';
			}
			this.params.asset_seq = this.selected_asset_seq;
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadCertificationAssetList();
		},
		async loadCertificationAssetList() {
			const params = { no_paging: 1, is_valid: 'Y' };
			const { data } = await fetchWithdrawAddressList(params).catch(
				commonError,
			);
			this.certification_asset_list = data;
		},
		async createWithdrawAddressCertification() {
			await createWithdrawAddress(this.params)
				.then(() => {
					alert(this.$t('merchant.address.alert'));
				})
				.catch(commonError);
		},
	},
};
</script>
